// API configuration
export const API_BASE_URL = (import.meta as any).env.VITE_API_URL || 'https://crosstalk-prod.ahmed-ovais.workers.dev'

// Helper function to build API URLs
export const apiUrl = (path: string) => `${API_BASE_URL}${path}`
